import React, {Component} from "react";

export default class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = {hasError: false, error: null};
    }

    static getDerivedStateFromError(error) {
        return {hasError: true, error};
    }

    componentDidCatch(error, errorInfo) {
        console.error("ErrorBoundary catch", error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            if (this.props.fallback) {
                return this.props.fallback;
            }
            if (this.props.fallbackComponent) {
                const FallbackComponent = this.props.fallbackComponent;
                return <FallbackComponent error={this.state.error} />;
            }
            return <div>Error</div>;
        }

        return this.props.children;
    }
}
